/**
 * Creates a new LoggerService.
 * @class LoggerService
 * @description This is logger service, responsible for logging the messages.
 */

import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { HttpErrorResponse } from '@angular/common/http';
import * as Sentry from "@sentry/browser";
import { Severity } from '@sentry/browser';
import { EnvironmentEnum } from '../helpers/enums/enums';

@Injectable({
  providedIn: 'root'
})
/**
 * logger service used to log the info , exception and etc
 */
export class LoggerService {
  constructor() { }

  /**
   * logging logs
   * @param obj hold up logs 
   * enable console log for logrocket
   */
  async log(message?: any, ...optionalParams: any[]) {
    //return
    // if (environment.env !== EnvironmentEnum.production) {
    //   console.log(message, optionalParams);
    // }
    console.log(message, optionalParams);
    try {
      let optMsg = null
      if (typeof message === 'object') {
        message = JSON.stringify(message, null, 4);
      }
      if (optionalParams && optionalParams.length > 0) {
        optMsg = optionalParams[0];
        if (typeof optMsg === 'object') {
          optMsg = JSON.stringify(optMsg, null, 4);
        }
      }
      message = message ? optMsg ? `${message} ${optMsg}` : message : '';
      Sentry.captureMessage(message, Severity.Info)
    } catch (error) { }
  }

  /**
   * logging errors
   * @param err 
   */
  error(message: string, optional?: any): void {
    console.log(message, optional)
    let extractedError = null;
    if (typeof message === 'string' && !optional) {
      extractedError = message;
    }
    else if (typeof message === 'string' && optional) {
      extractedError = this.extractError(optional) || "Handled unknown error";
    }
    else {
      extractedError = this.extractError(message) || "Handled unknown error";
    }
    if (extractedError) {
      if (typeof extractedError === 'string' && typeof message === 'string') {
        extractedError = `${message} ${extractedError}`;
      }
      else if (typeof extractedError === 'object' && typeof message === 'string') {
        extractedError["errMes"] = message;
      }
    }

    if (environment.env !== EnvironmentEnum.production) {
      if (message && optional) {
        console.error(message, extractedError);
      }
      else {
        console.error(extractedError);
      }
      Sentry.captureException(extractedError);
    }
    else {
      Sentry.captureException(extractedError);
    }
  }

  /**
   * extract error
   * @param error 
   */
  private extractError(error: any) {
    if (error && error.ngOriginalError) {
      error = error.ngOriginalError;
    }
    if (typeof error === "string" || error instanceof Error) {
      return error;
    }
    if (error instanceof HttpErrorResponse) {
      if (error.error instanceof Error) {
        return error.error;
      }
      if (error.error instanceof ErrorEvent) {
        return error.error.message;
      }
      if (typeof error.error === "string") {
        return `Server returned code ${error.status} with body "${error.error}"`;
      }
      return error.message;
    }
    return error;
  }

  /**
   * test and log stream 
   * @param msg 
   * @param stream 
   */
  async logStream(msg: any, stream: MediaStream) {
    try {
      if (stream) {
        console.log(`----------------[${msg}]---streamId: ${stream.id}---active: ${stream.active}}------------`)
        stream.getTracks().forEach(track => {
          //console.log(track);
          const kind = track.kind;
          console.log(`[${kind}_Get_Track_Info]`, track);
          console.log(`[${kind}_Get_Capabilities]`, track.getCapabilities())
          console.log(`[${kind}_Get_Constraints]`, track.getConstraints())
          console.log(`[${kind}_Get_Settings]`, track.getSettings())
        })
        console.log(`------------------------------------------------------`)
      }
    } catch (error) {
      console.error('logStream', error)
    }
  }


  logVideoRes(id: string) {
    try {
      let v = document.getElementById(id) as any
      if (v instanceof HTMLVideoElement) {
        let v2: any = v.srcObject
        let re = v2.getVideoTracks()[0].getSettings()
        console.log('video', re)
      }
    } catch (error) {

    }
  }



}
